/*
 * File: SearchButton.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: Implements and styles the button used to search for a patient.
 */
/**
 * RenderPatientSearch.js
 *
 * Renders a link to the patient search page
 */
import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Button, withStyles } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";

const styles = theme => ({
  button: {
    color: theme.palette.common.white,
    background: theme.palette.common.buttonGradient,
    width: "90%",
    letterSpacing: 1,
    marginTop: theme.spacing(2)
  },
  buttonIcon: {
    marginLeft: theme.spacing(1),
    padding: 0
  },
  buttonContainer: {
    textAlign: "center"
  }
});

const SearchButton = ({ classes }) => (
  <Link to="/patients">
    <div className={classes.buttonContainer}>
      <Button className={classes.button}>
        Search for Patient <SearchIcon className={classes.buttonIcon} />
      </Button>
    </div>
  </Link>
);

SearchButton.propTypes = {
  classes: PropTypes.object
};
export default withStyles(styles)(SearchButton);
